import React from 'react';
import { FormControl, InputGroup } from 'react-bootstrap';
import { normalizeId } from '../helpers/utility';

const RangeInput = ({
  id,
  key: fieldKey,
  title,
  onChange,
  onFormChange,
  value,
  preValue,
  className = '',
  minHint = 'MIN',
  maxHint = 'MAX',
  required = false,
  disabled = false,
  size
}) => {
  const baseId = id || fieldKey || normalizeId(title);
  const startId = `${baseId}.start`;
  const endId = `${baseId}.end`;
  const rangeValue = value || preValue;
  const startValue = rangeValue?.start ?? '';
  const endValue = rangeValue?.end ?? '';

  const handleChange = (e, part) => {
    if (onChange) onChange(e);
    if (onFormChange) onFormChange(e);
  };

  return (
    <div className={`d-flex flex-row align-items-center gap-1 gap-md-2 ${className}`}>
      <InputGroup size={size} className="flex-grow-1">
        <InputGroup.Prepend>
          <InputGroup.Text className="bg-primary-light">$</InputGroup.Text>
        </InputGroup.Prepend>
        <FormControl
          id={startId}
          name={startId}
          type="number"
          defaultValue={startValue}
          placeholder={minHint}
          required={required}
          disabled={disabled}
          onChange={e => handleChange(e, 'start')}
          style={{ minWidth: 0 }}
        />
      </InputGroup>
      <span className="text-muted align-self-center flex-shrink-0 px-1">–</span>
      <InputGroup size={size} className="flex-grow-1">
        <InputGroup.Prepend>
          <InputGroup.Text className="bg-primary-light">$</InputGroup.Text>
        </InputGroup.Prepend>
        <FormControl
          id={endId}
          name={endId}
          type="number"
          defaultValue={endValue}
          placeholder={maxHint}
          required={required}
          disabled={disabled}
          onChange={e => handleChange(e, 'end')}
          style={{ minWidth: 0 }}
        />
      </InputGroup>
    </div>
  );
};

export default RangeInput;
